import {useState, useEffect, useRef} from 'react'
import {Link} from "react-router-dom"
import CustomAvatar from '@src/views/components/CustomAvatar'
import {ArchiveIcon, UnarchiveIcon} from '@src/views/components/ArchiveIcons'
import {useDispatch, useSelector} from 'react-redux'
import {
    selectChatFromServer,
    selectedContactDetail,
    changeReduxState,
    archiveConversation,
    unarchiveConversation,
    getChatContactsFromServer
} from './store/actions'
import {NULL, RD} from './store/actionTypes'
import classnames from 'classnames'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {X, Search, Users, Archive, Inbox, Send, CornerUpLeft} from 'react-feather'
import {InputGroup, InputGroupAddon, Input, InputGroupText, Badge, Spinner, Nav, NavItem, NavLink} from 'reactstrap'
import BlankLogo from "@src/assets/images/avatars/avatar-blank.png"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {PropTypes} from "prop-types"

const TABS = [
    {key: 'inbox', label: 'Inbox', icon: <Inbox size={14}/>},
    {key: 'sent', label: 'Sent', icon: <Send size={14}/>},
    {key: 'archive', label: 'Archive', icon: <ArchiveIcon size={14}/>}
]

const SidebarLeft = props => {
    const {store, sidebar, handleSidebar, userSidebarLeft, handleUserSidebarLeft, chatRdContacts, selectedUserID, activeTab, onTabChange} = props
    const {chats, userProfile, contacts} = store
    const dispatch = useDispatch()
    const chatRdStoreSlice = useSelector(state => state.chatRd)

    const sweetAlert = withReactContent(Swal)

    const [query, setQuery] = useState('')
    const [active, setActive] = useState({})
    const [filteredContacts, setFilteredContacts] = useState([])
    const [contactsOfRDs, setContactsOfRDs] = useState([])
    const [contactsOfRDsForSearching, setContactsOfRDsForSearching] = useState([])
    const [loader, setLoader] = useState(true)

    const chatOnLoad = useRef(true)

    const handleUserClick = (type, contact) => {
        dispatch(changeReduxState(NULL.LOAD_SELECTED_RD_USER_CHAT, true))
        dispatch(selectChatFromServer(contact.chat_user))
        dispatch(selectedContactDetail(contact))
        setActive({type, id: contact.chat_user})
        if (sidebar === true) {
            handleSidebar()
        }
        dispatch({type: 'CLEAR_RD_CHAT_COUNT_ON_CLICK', payload: contact})
    }

    const handleArchive = (e, chatUser) => {
        e.stopPropagation()
        sweetAlert.fire({
            title: 'Archive this thread?',
            text: 'It will be moved to your Archive tab.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Archive',
            cancelButtonText: 'Cancel'
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(archiveConversation(chatUser))
                const isCurrentlyOpened = active?.id === chatUser || parseInt(selectedUserID) === chatUser
                if (isCurrentlyOpened && onTabChange) {
                    onTabChange('archive')
                }
            }
        })
    }

    const handleUnarchive = (e, chatUser) => {
        e.stopPropagation()
        sweetAlert.fire({
            title: 'Unarchive this thread?',
            text: 'It will be moved back to your Inbox.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Unarchive',
            cancelButtonText: 'Cancel'
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(unarchiveConversation(chatUser))
            }
        })
    }

    useEffect(() => {
        if (!!chatRdContacts && !!selectedUserID && chatOnLoad.current) {
            chatOnLoad.current = false
            const contact = chatRdContacts.data.filter(contact => contact.chat_user === parseInt(selectedUserID))
            setActive(null)
            handleUserClick('contact', contact[0])
        }

        if (!!chatRdContacts) {
            setContactsOfRDs(chatRdContacts.data || [])
            setContactsOfRDsForSearching(chatRdContacts.data || [])
            setLoader(false)
        }
    }, [chatRdContacts])

    useEffect(() => {
        const error = chatRdStoreSlice?.rdContactLoadError?.response?.status
        if (error && error !== 401) {
            sweetAlert.fire({
                title: 'Connection Error!',
                icon: 'error',
                html: '<p>Please reload the page.</p>',
                confirmButtonText: 'Reload',
                allowOutsideClick: false,
                showCancelButton: true
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload()
                }
            })
            dispatch({type: "RD_CONTACT_LOAD_ERROR_RESET"})
            setLoader(false)
        }
    }, [chatRdStoreSlice])

    const renderContacts = () => {
        const result = contactsOfRDs.filter(e => e.length !== 0)
        return result?.map(item => {
            return (
                <li className={classnames({
                    active: active.type === 'contact' && active.id === item?.chat_user
                })} key={item?.chat_user} style={{position: 'relative'}}>
                    <button className='btn btn-link p-0 d-flex align-items-center w-100 text-left' onClick={() => handleUserClick('contact', item)}>
                        <Link to={`/dashboard/rd/brands/${item?.brand_id}`} title="Go to profile"
                              onClick={(e) => e.stopPropagation()}>
                            <CustomAvatar
                                name={item?.brand_name || item?.name}
                                img={item.brand_logo || item.company_logo}
                                imgHeight='42'
                                imgWidth='42'
                                className="chat-img-animation avatar-img-fit-contain"
                            />
                        </Link>
                        <div className='chat-info flex-grow-1'>
                            <h5 className={classnames('mb-0', {
                                'avatar-brands-unpaid': item?.brand_is_paid === false
                            })}
                                title={item?.brand_name}
                            >
                                {item?.brand_name}
                            </h5>
                            <span className={classnames('small', {
                                'text-white': active.type === 'contact' && active.id === item?.chat_user,
                                'text-muted': !(active.type === 'contact' && active.id === item?.chat_user)
                            })}
                            >
                                {item?.last_message}
                            </span>
                        </div>
                        <div className='chat-meta text-nowrap d-flex flex-column align-items-end'>
                            {item?.unread_messages > 0 && (
                                <Badge className='float-right' color='danger' pill>
                                    {item?.unread_messages}
                                </Badge>
                            )}
                            {activeTab !== 'archive' ? (
                                <button
                                    className='btn btn-link p-0 mt-1 archive-btn'
                                    title='Archive thread'
                                    onClick={(e) => handleArchive(e, item?.chat_user)}
                                >
                                    <ArchiveIcon size={14}/>
                                </button>
                            ) : (
                                <button
                                    className='btn btn-link p-0 mt-1 unarchive-btn'
                                    title='Unarchive thread (Move back to Inbox)'
                                    onClick={(e) => handleUnarchive(e, item?.chat_user)}
                                >
                                    <UnarchiveIcon size={14}/>
                                </button>
                            )}
                        </div>
                    </button>
                </li>
            )
        })
    }

    const handleFilter = e => {
        setQuery(e.target.value)
        setContactsOfRDs(contactsOfRDsForSearching.filter(contact => contact?.brand_name?.toLowerCase().includes(e.target.value.toLowerCase())))
    }

    return store ? (
        <div className='sidebar-left'>
            <div className='sidebar'>
                <div className={classnames('sidebar-content', {show: sidebar === true})}>
                    <div className='sidebar-close-icon'>
                        <button className='btn btn-link p-0 bg-danger rounded-circle text-white' onClick={handleSidebar}>
                            <X/>
                        </button>
                    </div>
                    <div className='chat-fixed-search'>
                        <div className='d-flex align-items-center w-100'>
                            <InputGroup className='input-group-merge w-100'>
                                <InputGroupAddon addonType='prepend'>
                                    <InputGroupText className='round'>
                                        <Search className='text-muted' size={14}/>
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    value={query}
                                    className='round'
                                    placeholder='Search conversations'
                                    onChange={handleFilter}
                                />
                            </InputGroup>
                        </div>
                    </div>
                    <div className='d-flex border-bottom justify-content-between align-items-center'>
                        <h4 className='chat-list-title m-0 p-1'>
                            <Users size='18'/> Conversations
                        </h4>
                        {loader && (
                            <span className='m-0 p-1'>
                  <Spinner color='primary' style={{height: '16px', width: '16px'}}/>
                </span>
                        )}
                    </div>
                    {/* Inbox / Sent / Archive Tabs */}
                    <Nav tabs className='px-1 pt-1 border-bottom-0'>
                        {TABS.map(tab => (
                            <NavItem key={tab.key}>
                                <NavLink
                                    className={classnames('d-flex align-items-center gap-1', {active: activeTab === tab.key})}
                                    style={{cursor: 'pointer', fontSize: '12px', padding: '4px 8px'}}
                                    onClick={() => {
                                        if (activeTab !== tab.key) {
                                            setLoader(true)
                                            onTabChange(tab.key)
                                        }
                                    }}
                                >
                                    {tab.icon}&nbsp;{tab.label}
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>
                    <PerfectScrollbar className='chat-user-list-wrapper list-group' options={{wheelPropagation: false}}>
                        {loader ? (
                            <div className='py-1'>
                                {[1, 2, 3, 4, 5].map((i) => (
                                    <div key={i} className='skeleton-item'>
                                        <div className='skeleton-avatar' />
                                        <div className='skeleton-info'>
                                            <div className='skeleton-line title' />
                                            <div className='skeleton-line subtitle' />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <ul className='chat-users-list contact-list media-list pb-4'>
                                {contactsOfRDs?.length > 0 ? (
                                    renderContacts()
                                ) : (
                                    <li className='text-center py-3 text-muted border-top-0' style={{ fontSize: '0.85rem', listStyle: 'none' }}>
                                        No conversations found
                                    </li>
                                )}
                                <li className='text-center py-2 text-muted border-top-0 mt-1' style={{ fontSize: '0.85rem', listStyle: 'none', paddingBottom: '30px' }}>
                                    Total Conversations: {contactsOfRDs?.length || 0}
                                </li>
                            </ul>
                        )}
                    </PerfectScrollbar>
                </div>
            </div>
        </div>
    ) : null
}

SidebarLeft.propTypes = {
    store: PropTypes.shape({
        userProfile: PropTypes.object,
        contacts: PropTypes.array
    }),

    sidebar: PropTypes.bool,

    handleSidebar: PropTypes.func,

    userSidebarLeft: PropTypes.bool,

    handleUserSidebarLeft: PropTypes.func,

    chatRdContacts: PropTypes.shape({
        data: PropTypes.arrayOf(PropTypes.object)
    }),

    selectedUserID: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),

    activeTab: PropTypes.string,

    onTabChange: PropTypes.func
}

export default SidebarLeft